import { datadogRum } from '@datadog/browser-rum';
import { scrubPreviewTokens } from '@/utils/previewGuard';

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATIONID || '',
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '',
  site: 'datadoghq.com',
  service: import.meta.env.VITE_DATADOG_SERVICE || 'pcv4maxpro',
  sampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
  // PP-3: the preview URL carries a signed token; view/resource/action events all
  // carry the page URL. Scrub in place before the batch leaves the browser.
  beforeSend: event => {
    scrubPreviewTokens(event);
    return true;
  }
});

export default datadogRum;
